import axios from 'axios'
import { apiUrl } from '@/constants/config'
import store from '@/store'

export const axiosApiInstance = axios.create({
  baseURL: apiUrl
})

const axiosAuthenticated = axios.create({
  baseURL: apiUrl
})

axiosAuthenticated.interceptors.request.use(
  (config) => {
    const token = store.getters.token
    if (token) {
      config.headers = {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

export default axiosAuthenticated
